<app-page-layout>
  <article class="info-page">
    <h1>About the {{ toolName }}</h1>

    <section>
      <h2>Overview</h2>
      <p>
        The "{{ toolName }}" is the API and accompanying interface allowing authorized users to
        perform advanced queries on a postgresql database maintained by the Small Bodies Node (SBN)
        at the University of Maryland that continuously replicates the main database of the Minor
        Planet Center (MPC). The {{ toolName }} enables an authorized user to perform complex
        queries (subject to time and resource constraints) on the MPC database, and to download the
        results of those queries.
      </p>
      <p>{{ toolName }} = {{ toolDescriptor }}</p>
    </section>

    <section>
      <h2>Authorization</h2>
      <p>To use the {{ toolName }} you need to request an account from ddarg at umd dot edu.</p>
    </section>

    <section>
      <h2>Usage</h2>
      <p>
        Once you receive a username and password, you can log into the {{ toolName }} and submit
        (Postgres) SQL queries. You can also use the API directly as described in the
        <a routerLink="/api-info">API documentation</a>.
      </p>
      <p>
        As with any SQL query, read the
        <a
          href="https://docs.minorplanetcenter.net/mpc-ops-docs/data-and-services/replicated-tables-schema/"
        >
          table schema
        </a>
        first and then plan your requests carefully.
      </p>
    </section>

    <section>
      <h2>Help</h2>
      <p>For issues or bug reports, please contact ddarg at umd dot edu.</p>
    </section>
  </article>
</app-page-layout>
